module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/clock-0cbd7b6c74689ec0f6906af0c5beee27.svg";